import { SET_SCANNED_CODE, SetScannedCodeAction } from './types';

export function setScannedCode(scannedCode: String): SetScannedCodeAction {
  return {
    type: SET_SCANNED_CODE,
    payload: { scannedCode },
  };
}
